module.exports = {"pageTitleText":"Api Keys","hintText":"Please confirm that the ID and KEY match correctly to avoid something wrong.","captcha":"Smart Captcha","vaptcha":"Gesture Challenge","placeholder":"Please enter"}


//////////////////
// WEBPACK FOOTER
// ./src/i18n/en-US/apiKeys.json
// module id = AkC1
// module chunks = 3